// extracted by mini-css-extract-plugin
export default {"container":"zO-z","topReviewHeading":"AO-z","criticalReview":"BO-z","favorableReview":"CO-z","vsSeparator":"DO-z"};